export const categoryColors: { [key: string]: string } = {
  "Hardwood Flooring Installers": "#8B5CF6",
  "Carpet Installers": "#D946EF",
  "Vinyl Flooring Installers": "#F97316",
  "Retailers": "#0EA5E9",
  "Manufacturers": "#10B981",
  "Conventions": "#F59E0B",
  "Training Events": "#EC4899",
  "Distributors": "#6366F1",
  "Flooring Reps": "#14B8A6",
  "Mentors": "#8B5CF6",
};

export const mapConfig = {
  style: 'mapbox://styles/mapbox/streets-v12',
  initialView: {
    center: [-98.5795, 39.8283] as [number, number],
    zoom: 4,
    minZoom: 3,
    maxZoom: 15
  }
};